/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CandidateDocumentType;

(function (CandidateDocumentType) {
  CandidateDocumentType["ATTACHMENT"] = "attachment";
  CandidateDocumentType["RESUME"] = "resume";
  CandidateDocumentType["INSURANCE"] = "insurance";
})(CandidateDocumentType || (CandidateDocumentType = {}));